import React, { useState, useEffect } from "react";
import {
  ArrowIndicator,
  ImportSource,
  DividerWrap,
  DividerWrapSmall,
  SocialLinks,
  //ShowBirthday,
  createSalientTheme,
  networkingSeries,
  AddContactWidget,
  fetchNetworkingStagesStatus,
  ClickToPhone,
  ManageCategoriesWidget,
  SalientCheckbox
} from "./SalientComponents.js";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tabs,
  Tab
} from "@material-ui/core";
import "./styles.css";
import { MergeWidget } from "./MergePage.js";
import { red } from "@material-ui/core/colors";

function checkmsg(){
  const query = new URLSearchParams(window.location.search.substring(1));
  const msg = query.get('msg');
    if(msg === "401"){
    alert("Incorrect username or password for iCloud");
    window.location = "/prism/contact/";
  }
 
}
checkmsg();
const theme = createSalientTheme();
const ContactRow = props => {
  // alert(JSON.stringify(props));
  return (
    <div
      data-midnight=""
      data-column-margin="default"
      data-bg-mobile-hidden=""
      className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-middle standard_section contactRow"
      style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}
    >
      <div className="row-bg-wrap">
        <div className="row-bg   " />
      </div>
      <div className="col span_12  center">
        <div
          style={{ marginTop: "1%" }}
          className="vc_col-sm-3 wpb_column column_container vc_column_container col child_column no-extra-padding"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div
                className="nectar_icon_wrap"
                data-style="default"
                data-draw=""
                data-border-thickness="2px"
                data-padding="0px"
                data-color="extra-color-1"
              >
                <div className="nectar_icon">
                {/*=========== PS: SB 12/28/2020 Display Contact Image from Database if not null =======================*/}
                  {props.contact.pictureRef ==null|| props.contact.pictureRef ==""?(
                  <i
                    style={{
                      fontSize: "70px",
                      lineHeight: "70px",
                      height: "70px",
                      width: "70px"
                    }}
                    className={
                      props.checked === true
                        ? "hidden"
                        : "fa fa-user-circle hover-off"
                    }
                  />
                   ):
                  (
                    <img
                      src={props.contact.pictureRef}
                      style={{
                        fontSize: "70px",
                        lineHeight: "70px",
                        height: "70px",
                        width: "70px",
                        borderRadius: 50,
                      }}
                      className={
                        props.checked === true
                          ? "hidden"
                          : "fa fa-user-circle hover-off"
                      }
                    />
                  )
                    }
                {/* =========================================================================== */}
                  <div
                    className={props.checked === true ? "visible" : "hover-on"}
                    style={{ lineHeight: "70px" }}
                  >
                    <SalientCheckbox
                      type="checkbox"
                      checked={props.checked}
                      value={props.contact.id}
                      onChange={() => props.checkboxCallback(props.contact.id)}
                      className="clickable"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="vc_col-sm-3 wpb_column column_container vc_column_container col child_column no-extra-padding"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <a
                    href={
                      "/prism/contact-detail/" +
                      props.contact.name.replace(/\s/g, "") +
                      "/" +
                      props.contact.id +
                      "?contactId=" +
                      props.contact.id
                    }
                  >
                    <span style={props.contact.firstName == "Missing"||props.contact.lastName == "Missing"?{color:"red"}:{}}>
                    <strong>
                      {props.contact.firstName} {props.contact.lastName}{" "}
                      {(props.contact.firstName == null ||
                        props.contact.firstName === "") &&
                      (props.contact.lastName == null ||
                        props.contact.lastName === "")
                        ? "Unknown"
                        : null}
                    </strong>
                    </span>
                  </a>
                  <br />
                  {props.contact.emailOne != null && props.contact.emailOne !== "" ? (
                    <a
                      href={"mailto:" + props.contact.emailOne}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-tiny fa fa-envelope-o extra-color-3" />
                    </a>
                  ) : null}
                 
                  {props.contact.phone != null ? (
                    <ClickToPhone phone={props.contact.phone} />
                  ) : null}
                   {/* <br />
                  {props.contact.birthday != null && props.contact.birthday !== "" ? (
                   
                    <span>
                      <ShowBirthday birthdayValue={props.contact.birthday}/>
                    </span>
                  ) : null} */}

                  <SocialLinks contact={props.contact} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="vc_col-sm-3 wpb_column column_container vc_column_container col child_column no-extra-padding"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  {props.contact.networkingStage > -1 &&
                  props.contact.networkingStage <
                    networkingSeries[0].stages.length ? (
                    <p>
                      <i
                        className={
                          "icon-tiny extra-color-3 " +
                          networkingSeries[0].stages[
                            props.contact.networkingStage
                          ].icon
                        }
                      />
                      {
                        networkingSeries[0].stages[
                          props.contact.networkingStage
                        ].name
                      }
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="vc_col-sm-3 wpb_column column_container vc_column_container col child_column no-extra-padding"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  {props.contact.categories != null ? (
                    <div>
                      <i
                        className="icon-tiny fa fa-tag extra-color-3"
                        style={{ color: "#a3a3a3" }}
                      />
                      {props.contact.categories !== null
                        ? props.contact.categories.slice(0, 30) +
                          (props.contact.categories.length > 30 ? "..." : "")
                        : null}
                    </div>
                  ) : null}
                  <ImportSource importSource={props.contact.importSource} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Category = props => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={
        props.filters != null &&
        props.filters["categories"] &&
        props.filters["categories"].indexOf(props.category.name) > -1
          ? "category selected"
          : "category"
      }
    >
      <div
        className="title"
        onClick={() => props.filterCallback("categories", props.category.name)}
      >
        <i className="icon-tiny fa fa-tag extra-color-3" />
        {props.category.name} <ItemsCount count={props.category.count} />
      </div>
      <div className="action">
        <i
          className="icon-tiny fa fa-pencil extra-color-3 clickable"
          style={{ color: "#a3a3a3" }}
          onClick={() => setOpen(true)}
        />
        <i
          className="icon-tiny fa fa-trash-o extra-color-3 clickable"
          style={{ color: "#a3a3a3" }}
          onClick={() => {
            if (
              window.confirm("Are you sure you want to delete this category?")
            ) {
              props.deleteCallback(props.category.id);
            }
          }}
        />
        <EditCategoryDialog
          open={open}
          setOpen={setOpen}
          category={props.category}
          editCallback={props.editCallback}
        />
      </div>
    </div>
  );
};


const EditCategoryDialog = props => {
  const [category, setCategory] = useState(props.category.name);
  return (
    <Dialog
      open={props.open}
      onClose={() => props.setOpen(false)}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle>Edit Category</DialogTitle>
      <DialogContent dividers>
        <input
          type="text"
          value={category}
          onChange={e => setCategory(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => props.setOpen(false)}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            props.editCallback(props.category.id, category);
            props.setOpen(false);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
const Categories = props => {
  const [open, setOpen] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div className="wpb_text_column wpb_content_element ">
      <div className="wpb_wrapper">
        <div className="menuContacts">
          <div>
            <ArrowIndicator open={open} onClick={() => setOpen(!open)} />
            Categories{" "}
            <i
              className="icon-tiny fa fa-plus extra-color-2"
              onClick={() => setModalOpen(true)}
            />
          </div>

          <Dialog
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            fullWidth={true}
            maxWidth="sm"
          >
            <DialogTitle>Add Category</DialogTitle>
            <DialogContent dividers>
            <div style={{ display: "flex",
              justifyContent: "center",
              alignItems: "center" }}>
              <div style={{ flex: 4 }}>
              <input
                id="categoryText"
                type="text"
                placeholder="New Category Here..."
                onChange={e => {
                  props.categoryInputCallback(e.target.value);
                  //setNewCategory(e.target.value);
                  //setModalOpen(true);
                }}
              />
              </div>
               {/* <Button
                variant="outlined"
                onClick={() => {
                  props.addCategoryCallback();
                 // setModalOpen(false);
                }}
              >
                Save
              </Button> */}
              <div style={{ flex: 1, textAlign: "center" }}>
              <Button variant="outlined" onClick={() =>  props.addCategoryCallback()}>
                Save
              </Button>
            </div>
            </div>
            <div className="manageCategoriesWidget">
            {props.categories != null && props.categories.length > 0
              ? props.categories.map(c => {
                  return (
                    <div key={"category" + c.id}>
                      {c.name}
                    </div>
                  );
                })
              : null}
          </div>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={() => setModalOpen(false)}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div className={open ? "menuItems" : "hidden"}>
          {props.categories != null && props.categories.length > 0
            ? props.categories.map(c => (
                <Category
                  key={c.id}
                  category={c}
                  filters={props.filters}
                  filterCallback={props.filterCallback}
                  deleteCallback={props.deleteCallback}
                  editCallback={props.editCallback}
                />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

const Mentoring = props => {
  const [open, setOpen] = useState(true);
  return (
    <div className="wpb_text_column wpb_content_element ">
      <div className="wpb_wrapper">
        <div className="menuContacts" onClick={() => setOpen(!open)}>
          <ArrowIndicator open={open} />
          Mentoring
        </div>
        <div className={open ? "menuItems" : "hidden"}>
          <div
            className={
              props.filters !== null &&
              props.filters.filter(
                f => f.field === "mentor" && f.value === "Mentor"
              ).length > 0
                ? "selected"
                : null
            }
            onClick={() => props.filterCallback("mentor", "Mentor")}
          >
            <i className="icon-tiny fa fa-diamond extra-color-3" />
            Mentor
          </div>
          <div
            className={
              props.filters !== null &&
              props.filters.filter(
                f => f.field === "mentor" && f.value === "Mentee"
              ).length > 0
                ? "selected"
                : null
            }
            onClick={() => props.filterCallback("mentor", "Mentee")}
          >
            <i className="icon-tiny icon-leaf extra-color-3" />
            Mentee
          </div>
        </div>
      </div>
    </div>
  );
};

const ItemsCount = ({ count }) => {
  return count != null ? <span className="itemsCount">({count})</span> : null;
};

const StageMenuItem = props => {
  return (
    <div
      className={
        props.filters != null &&
        props.filters["networkingStage"] != null &&
        props.filters["networkingStage"].filter(f=>parseInt(props.stage,10) === parseInt(f,10)).length > 0
          ? "selected"
          : null
      }
      onClick={() => props.filterCallback("networkingStage", props.stage)}
    >
      <i className={props.icon} />
      {props.name} <ItemsCount count={props.count} />
    </div>
  );
};

const Stages = props => {
  const [open, setOpen] = useState(true);
  return (
    <div style={{ marginBottom: "10px" }}>
      <div className="menuContacts" onClick={() => setOpen(!open)}>
        <ArrowIndicator open={open} />
        Stage
      </div>
      <div className={open ? "menuItems" : "hidden"}>
        <StageMenuItem
          name="BUILD"
          stage={0}
          icon="icon-tiny iconsmind-Wrench extra-color-3"
          filters={props.filters}
          filterCallback={props.filterCallback}
          count={
            props.statuses != null &&
            parseInt(props.statuses.BuildInProgress, 10) >= 0
              ? props.statuses.BuildInProgress
              : null
          }
        />
        <StageMenuItem
          name="DISCOVER"
          stage={1}
          icon="icon-tiny iconsmind-Search-People extra-color-3"
          filters={props.filters}
          filterCallback={props.filterCallback}
          count={
            props.statuses != null &&
            parseInt(props.statuses.DiscoverInProgress, 10) >= 0
              ? props.statuses.DiscoverInProgress
              : null
          }
        />
        <StageMenuItem
          name="CONNECT"
          stage={2}
          icon="icon-tiny iconsmind-Plastic-CupPhone extra-color-3"
          filters={props.filters}
          filterCallback={props.filterCallback}
          count={
            props.statuses != null &&
            parseInt(props.statuses.ConnectInProgress, 10) >= 0
              ? props.statuses.ConnectInProgress
              : null
          }
        />
        <StageMenuItem
          name="ASSESS"
          stage={3}
          icon="icon-tiny iconsmind-Puzzle extra-color-3"
          filters={props.filters}
          filterCallback={props.filterCallback}
          count={
            props.statuses != null &&
            parseInt(props.statuses.AssessInProgress, 10) >= 0
              ? props.statuses.AssessInProgress
              : null
          }
        />
        <StageMenuItem
          name="ENGAGE"
          stage={4}
          icon="icon-tiny iconsmind-Checked-User extra-color-3"
          filters={props.filters}
          filterCallback={props.filterCallback}
          count={
            props.statuses != null &&
            parseInt(props.statuses.EngageInProgress, 10) >= 0
              ? props.statuses.EngageInProgress
              : null
          }
        />
        <StageMenuItem
          name="MAINTAIN"
          stage={5}
          icon="icon-tiny iconsmind-Heart2 extra-color-3"
          filters={props.filters}
          filterCallback={props.filterCallback}
          count={
            props.statuses != null &&
            parseInt(props.statuses.MaintainInProgress, 10) >= 0
              ? props.statuses.MaintainInProgress
              : null
          }
        />
      </div>
    </div>
  );
};

const Status = props => {
  const [open, setOpen] = useState(true);
  return (
    <div>
      <div className="menuContacts" onClick={() => setOpen(!open)}>
        <ArrowIndicator open={open} />
        Status
      </div>
      <div className={open ? "menuItems" : "hidden"}>
        <div
          className={
            props.filters != null &&
            props.filters["networkingStatus"] != null &&
            props.filters["networkingStatus"].indexOf("In Progress") > -1
              ? "selected"
              : null
          }
          onClick={() =>
            props.filterCallback("networkingStatus", "In Progress")
          }
        >
          <i className="icon-tiny iconsmind-Sand-watch2 extra-color-3" />
          In Progress{" "}
          <ItemsCount
            count={
              props != null &&
              props.statuses != null &&
              parseInt(props.statuses.Active, 10) > 0
                ? props.statuses.Active
                : 0
            }
          />
        </div>
        <div
          className={
            props.filters != null &&
            props.filters["networkingStatus"] != null &&
            props.filters["networkingStatus"].indexOf("Complete") > -1
              ? "selected"
              : null
          }
          onClick={() => props.filterCallback("networkingStatus", "Complete")}
        >
          <i className="icon-tiny iconsmind-Yes extra-color-3" />
          Complete{" "}
          <ItemsCount
            count={
              props != null &&
              props.statuses != null &&
              props.statuses.Complete > 0
                ? parseInt(props.statuses.Complete, 10)
                : 0
            }
          />
        </div>
      </div>
    </div>
  );
};

const Networking = props => {
  const [open, setOpen] = useState(true);

  return (
    <div className="wpb_text_column wpb_content_element ">
      <div className="wpb_wrapper">
        <div className="menuItems">Networking</div>
        <div style={{ marginBottom: "10px" }}>
          <div className="menuContacts" onClick={() => setOpen(!open)}>
            <ArrowIndicator open={open} />
            Process
          </div>
          <div className={open ? "menuItems" : "hidden"}>
            <div
              className={
                props.filters != null &&
                props.filters["networkingProcess"] != null &&
                props.filters["networkingProcess"].indexOf("Active") > -1
                  ? "selected"
                  : null
              }
              onClick={() =>
                props.filterCallback("networkingProcess", "Active")
              }
            >
              <i className="icon-tiny iconsmind-Loading-3 extra-color-3" />
              Active{" "}
              <ItemsCount
                count={props.statuses != null ? props.statuses.Active : 0}
              />
            </div>
            <div
              className={
                props.filters != null &&
                props.filters["networkingProcess"] != null &&
                props.filters["networkingProcess"].indexOf("Inactive") > -1
                  ? "selected"
                  : null
              }
              onClick={() =>
                props.filterCallback("networkingProcess", "Inactive")
              }
            >
              <i className="icon-tiny iconsmind-Close-Window extra-color-3" />
              Inactive{" "}
              <ItemsCount
                count={props.statuses != null ? props.statuses.InActive : 0}
              />
            </div>
          </div>
        </div>

        <Stages
          filterCallback={props.filterCallback}
          filters={props.filters}
          statuses={props.statuses}
        />
        <Status
          filterCallback={props.filterCallback}
          filters={props.filters}
          statuses={props.statuses}
        />
      </div>
    </div>
  );
};

const ImportSourceMenuItem = props => {
  return props.counts != null &&
    props.name != null &&
    props.counts[props.name] > 0 ? (
    <div
      className={
        props.filters !== null &&
        props.filters["importSource"] != null &&
        props.filters["importSource"].indexOf(props.name) > -1
          ? "selected"
          : null
      }
      onClick={() => props.filterCallback("importSource", props.name)}
    >
      {props.icon != null && props.icon !== "" ? (
        <i className={props.icon} />
      ) : null}
      {props.name} <ItemsCount count={props.counts[props.name]} />
    </div>
  ) : null;
};

const ContactsMenu = props => {
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    if (
      props != null &&
      props.contacts != null &&
      props.contacts.length > 0 &&
      counts == null
    ) {
      let google = 0;
      let icloud = 0;
      let prism = 0;
      let linkedin = 0;
      props.contacts.forEach(c => {
        if (c.importSource.indexOf("Google") >= 0) {
          google++;
        }
        if (c.importSource.indexOf("iCloud") >= 0) {
          icloud++;
        }
        if (c.importSource.indexOf("PRISM") >= 0) {
          prism++;
        }
        if (c.importSource.indexOf("LinkedIn") >= 0) {
          linkedin++;
        }
      });
      setCounts({
        Google: google,
        iCloud: icloud,
        PRISM: prism,
        LinkedIn: linkedin
      });
    }
  }, [props, counts]);

  return (
    <div className="wpb_text_column wpb_content_element ">
      <div className="wpb_wrapper">
        <Tooltip title="See All Contacts">
          <div
            onClick={() => props.clearFilterCallback()}
            className="menuContacts"
          >
            <i className="icon-tiny fa fa-address-book-o extra-color-3" />
            All Contacts{" "}
            <ItemsCount
              count={props.contacts != null ? props.contacts.length : 0}
            />
          </div>
        </Tooltip>
        {/* <div className="menuContacts" onClick={() => props.setOpenMerge(true)}>
          <i className="icon-tiny fa fa-compress extra-color-3 clickable" />
          Merge Contacts{" "}
          {props.collisions != null && props.collisions.length > 0 ? (
            <i
              className="icon-tiny fa fa-flag extra-color-3"
              style={{ color: "#65A603" }}
            />
          ) : null}
        </div> */}
        <div className="menuContacts">
          <i className="icon-tiny fa fa-history extra-color-3" />
          Recently Added
        </div>
        <div className="menuContacts" onClick={() => setOpen(!open)}>
          <ArrowIndicator open={open} />
          Import Source
        </div>
        <div className={open ? "menuItems" : "hidden"}>
          <span style={{ color: "#a3a3a3" }}>
            <ImportSourceMenuItem
              name="Google"
              icon="icon-tiny fa fa-google extra-color-1"
              filters={props.filters}
              filterCallback={props.filterCallback}
              counts={counts}
            />
            <ImportSourceMenuItem
              name="iCloud"
              icon="icon-tiny fa fa-apple extra-color-1"
              filters={props.filters}
              filterCallback={props.filterCallback}
              counts={counts}
            />
            <ImportSourceMenuItem
              name="LinkedIn"
              icon="icon-tiny fa fa-linkedin extra-color-1"
              filters={props.filters}
              filterCallback={props.filterCallback}
              counts={counts}
            />
            <ImportSourceMenuItem
              name="PRISM"
              icon=""
              filters={props.filters}
              filterCallback={props.filterCallback}
              counts={counts}
            />
          </span>
        </div>
      </div>
      <MergeWidget
        wordpressId={props.wordpressId}
        open={props.openMerge}
        setOpen={props.setOpenMerge}
        nonce={props.nonce}
      />
    </div>
  );
};

const ContactsPage = props => {
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [filters, setFilters] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [checkedList, setCheckedList] = useState([]);
  const [categories, setCategories] = useState(null);
  const [categoryInput, setCategoryInput] = useState("");
  const [addContactModal, setAddContactModal] = useState(false);
  const [importContactModal, setImportContactModal] = useState(false);
  const [page, setPage] = useState(0);
  const [importSource, setImportSource] = useState("");
  const [notes, setNotes] = useState(null);
  const [importSourceTab, setImportSourceTab] = useState(0);
  const [collisions, setCollisions] = useState(null);
  const [openMerge, setOpenMerge] = useState(false);
  const [statuses, setStatuses] = useState(null);
  const[mobileSubMenu,setMobileSubMenu] = useState(false);
  const[mobleCategoryPopup,setmobleCategoryPopup] = useState(false);

  const count = 0;

  const manageCategoriesWidget = (
    <ManageCategoriesWidget
      wordpressId={props.id}
      contacts={
        contacts != null && checkedList.length > 0
          ? contacts.filter(c => checkedList.includes(parseInt(c.id, 10)))
          : null
      }
      contactsCallback={setContacts}
      nonce={props.nonce}
    />
  );

  // useEffect(() =>{
  //   function checkmsg(){
  //     const query = new URLSearchParams(window.location.search.substring(1));
  //     const msg = query.get('msg');
  //     console.log(query);
  //     console.log(msg);
  //       if(msg = null){
  //       alert(msg);
  //       return;
  //     }
  //   }
  // //}
  // //)
  // checkmsg();

  useEffect(() => {
    if (statuses == null) {
      fetchNetworkingStagesStatus({
        wordpressId: props.id,
        callback: setStatuses,
        nonce: props.nonce
      });
    }
  }, [props.id, statuses, props.nonce]);

  const fetchNotes = async wid => {
    await fetch("/wp-json/prism/v1/all-notes/" + wid, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => setNotes(result));
  };

  const fetchContacts = async id => {
    await fetch("/wp-json/prism/v1/contacts/" + id, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => {
        setContacts(result);
        setFilteredContacts(result);
      });
  };

  const fetchCategories = async id => {
    await fetch("/wp-json/prism/v1/categories/" + id, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => {
        setCategories(result);
      });
  };

  function sortContacts(a, b) {
    let r = 0;
    r = a < b ? 1 : -1;
    return r;
  }

  function addFilter(field, value) {
    console.log(field + " " + value);
    console.log(filters);
    setFilters(filters => {
      let f =
        filters === null
          ? { [field]: [value] }
          : filters[field] == null
          ? { ...filters, [field]: [value] }
          : filters[field] != null && filters[field].indexOf(value) > -1
          ? {
              ...filters,
              [field]: filters[field].filter(item => item !== value)
            }
          : { ...filters, [field]: [...filters[field], value] };
      console.log(f);
      return f;
    });
  }

  useEffect(() => {
    fetchContacts(props.id);
    fetchCategories(props.id);
    fetchNotes(props.id);
    const filterByUrl = () => {
      const url = new URL(window.location);
      const params = new URLSearchParams(url.search);
      if (params.get("q") != null) {
        setSearchTerm(params.get("q"));
      }
      if (params.get("c") != null) {
        addFilter("categories", params.get("c"));
      }
      if (params.get("networkingProcess") != null) {
        addFilter("networkingProcess", params.get("networkingProcess"));
      }
      if (params.get("networkingStage") != null) {
        addFilter("networkingStage", parseInt(params.get("networkingStage"),10));
      }
      if (params.get("networkingStatus") != null) {
        addFilter("networkingStatus", params.get("networkingStatus"));
      }
    };
    filterByUrl();
  }, [props.id]);

  useEffect(() => setPage(0), [filteredContacts]);
  useEffect(() => setCheckedList([]), [contacts, categories, setCheckedList]);

  useEffect(() => {
    const fetchCollisions = async wordpressId => {
      await fetch("/wp-json/prism/v1/collisions/" + wordpressId, {
        headers: { "X-WP-Nonce": props.nonce }
      })
        .then(response => response.json())
        .then(result => setCollisions(result));
    };
    if (!openMerge) {
      fetchCollisions(props.id);
    }
  }, [openMerge, props.id, props.nonce]);

  useEffect(() => {
    //attach notes to contacts
    if (contacts != null && contacts.length > 0 && notes != null) {
      contacts.forEach(c => {
        c.notes = notes.filter(n => n.contactId === c.id);
      });
    }
  }, [contacts, notes]);

  useEffect(() => {
    //split contact.categories string and count
    if (
      contacts != null &&
      contacts.length > 0 &&
      categories != null &&
      categories.length > 0
    ) {
      categories.forEach(c => {
        const total = contacts.filter(
          con => con.categories != null && con.categories.match(new RegExp("(?:^|, )"+c.name+"(?:, |$)"))
          // && con.categories.indexOf(c.name) >= 0
        );
        c.count = total != null ? total.length : 0;
        return c;
      });
    }
  }, [contacts, categories]);

  useEffect(() => {
    if (
      contacts != null &&
      contacts.length > 0 &&
      collisions != null &&
      collisions.length > 0
    ) {
      contacts.forEach(c => {
        c.collision = collisions.filter(
          col => col.firstId === c.id || col.secondId === c.id
        );
      });
    }
  }, [contacts, collisions]);

  useEffect(() => {
    //apply filters
    if (filters !== null || searchTerm != null) {
      let c = contacts.slice();
      if (filters !== null) {
        if (
          filters["networkingProcess"] &&
          filters["networkingProcess"].length > 0
        ) {
          if (filters["networkingProcess"].indexOf("Active") > -1) {
            c = c.filter(contact => contact.networkingStage > -1);
          }
          if (filters["networkingProcess"].indexOf("Inactive") > -1) {
            c = c.filter(
              contact => parseInt(contact.networkingStage, 10) === -1
            );
          }
        }
        if (
          filters["importSource"] != null &&
          filters["importSource"].length > 0
        ) {
          c = c.filter(
            contact =>
              contact.importSource != null &&
              filters["importSource"].every(
                i => contact.importSource.indexOf(i) > -1
              )
          );
        }
        if (filters["categories"] != null && filters["categories"].length > 0) {
          c = c.filter(
            contact =>
              contact.categories != null &&
              filters["categories"].every(
                i => contact.categories.match(new RegExp("(?:^|, )"+i+"(?:, |$)"))
                // contact.categories.indexOf(i) > -1
              )
          );
        }
        if (
          filters["networkingStage"] != null &&
          filters["networkingStage"].length > 0
        ) {
          c = c.filter(contact =>
            filters["networkingStage"].every(
              i => parseInt(i, 10) === parseInt(contact.networkingStage, 10)
            )
          );
        }
        if (
          filters["networkingStatus"] != null &&
          filters["networkingStatus"].length > 0
        ) {
          if (filters["networkingStatus"].indexOf("In Progress") > -1) {
            c = c.filter(
              contact =>
                contact.networkingStage > -1 && contact.networkingStage < 6
            );
          }
          if (filters["networkingStatus"].indexOf("Complete") > -1) {
            c = c.filter(contact => contact.networkingStage > 0);
          }
        }
      }

      //narrow results by search term
      if (searchTerm != null) {
        const st = searchTerm.toLowerCase();
        c = c.filter(
          r =>
            (r.name != null && r.name.toLowerCase().includes(st)) ||
            (r.phone != null && r.phone.toLowerCase().includes(st)) ||
            (r.email != null && r.email.toLowerCase().includes(st)) ||
            (r.company != null && r.company.toLowerCase().includes(st)) ||
            (r.notes != null &&
              r.notes.length > 0 &&
              r.notes.filter(n => n.note.toLowerCase().indexOf(st) > -1)
                .length > 0)
        );
      }
      setFilteredContacts(c);
    }
  }, [searchTerm, filters, contacts]);

  function clearFilter() {
    setCheckedList([]);
    setFilters(null);
    setSearchTerm("");
    setFilteredContacts(contacts);
  }

  function handleCheck(v) {
    setCheckedList(prev => {
      let t = parseInt(v, 10);
      let r =
        prev.findIndex(i => i === t) > -1
          ? prev.filter(i => i !== t)
          : [...prev, t];
      return r;
    });
  }

  function handleCheckAll(v) {
    setCheckedList(
      v
        ? () => {
            let r = [];
            filteredContacts.map(f => r.push(parseInt(f.id, 10)));
            return r;
          }
        : []
    );
  }

  function mailTo() {
    if (checkedList.length === 0) {
      alert("Select some contacts first.");
    } else if(checkedList.length > 95){
      alert("Maximum limit of recipients exceeded, please select upto 95 contacts for this feature.");
    }
    else {
      let r = "";
      filteredContacts.forEach(f => {
        let flag = checkedList.includes(parseInt(f.id));
        if ( 
          flag == true &&
          f.email != null &&
          f.email !== ""
        ) {
           r = r + f.email + ";";
        }
      });
      document.location.href = "mailto:" + r;
      window.location = "/prism/contact/";
      // window.open("mailto:" + r,"_blank"); 
    }
  }

  function manageCategoryValidation(){
    if (checkedList.length === 0) {
      alert("Select some contacts first.");
    } else {
      return null;
    }

  }

  function handleDelete() {
    if (checkedList.length === 0) {
      alert("Select some contacts to delete.");
    } else {
      const r = window.confirm(
        "Are you sure you want to delete the selected contacts?"
      );
      if (r) {
        pushDeleteContact(checkedList);
      }
    }
  }

  const pushDeleteContact = idList => {
    fetch("/wp-json/prism/v1/delete-contact/", {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({ idList: idList, wordpressId: props.id })
    })
      .then(response => response.json())
      .then(result => fetchContacts(props.id));
  };

  const handleAddCategory = () => {
    if(categoryInput != ""){
    const allcat = categories;
    const flag = allcat.some(r=> r.name === categoryInput);
    if(flag == false)
    {
    fetch("/wp-json/prism/v1/add-category/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({ name: categoryInput, wordpressId: props.id })
    })
      .then(response => response.json())
      .then(result => fetchCategories(props.id)
       .then(()=>{document.getElementById('categoryText').value = null})
       .then(()=>{setCategoryInput("");}));
    }
    else{
      alert('Category already exist');
    }
  }
  };

  const editCategory = (id, name) => {
    fetch("/wp-json/prism/v1/edit-category/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({ id: id, name: name, wordpressId: props.id })
    })
      .then(response => response.json())
      .then(result => {
        setCategories(result);
        fetchContacts(props.id);
      });
  };

  const deleteCategory = categoryId => {
    fetch("/wp-json/prism/v1/delete-category/", {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({ id: categoryId, wordpressId: props.id })
    })
      .then(response => response.json())
      .then(result => {
        setCategories(result);
        fetchContacts(props.id);
      });
  };

  const collideAndMerge = () => {
    if (checkedList != null && checkedList.length === 2) {
      const r = window.confirm(
        "Are you sure you want to merge the selected contacts?"
      );
      if (r) {
        fetch("/wp-json/prism/v1/collide-and-merge/", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": props.nonce
          },
          body: JSON.stringify({ idList: checkedList, wordpressId: props.id })
        })
          .then(response => response.json())
          .then(result => {
            clearFilter();
            setContacts(result);
          });
      }
    } else {
      alert("Please select 2, and only 2 contacts to merge.");
    }
  };

  const MobilcategorySearch = ({ open, setOpen }) => {
 
    //const [open, setOpen] = useState(false);
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        style={{ zIndex: 26000 }}
        fullWidth={true}
        maxWidth="sm"
      >
           <DialogTitle>Category Search</DialogTitle>
           <DialogContent>
           <div className="wpb_wrapper">
                              <select
                                onChange={e =>
                                  (window.location.href =
                                    "/prism/contact/?c=" + e.target.value)
                                }
                              >
                                <option>Search Categories</option>
                                {categories != null
                                  ? categories.map(c => (
                                      <option value={c.name}>{c.name}</option>
                                    ))
                                  : null}
                              </select>
                            </div>
           </DialogContent>
           <DialogActions>
                                    <Button
                                      variant="outlined"
                                      onClick={() =>
                                        setOpen(false)
                                      }
                                    >
                                      Close
                                    </Button>
                                                             
                                  </DialogActions>
        </Dialog>
    );
  }
 
 
const MobileSubMenu = ({ open, setOpen }) => {
  //const [open, setOpen] = useState(false);
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      style={{ zIndex: 26000 }}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle></DialogTitle>
      <DialogContent>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper" style={{fontWeight:700}}>
                              <Tooltip title="Select All Contacts">
                                <input
                                  type="checkbox"
                                  onChange={e =>
                                   {handleCheckAll(e.target.checked)}
                                  }
                                  className="clickable"
                                  checked={checkedList.length>0?"checked":""}
                                />
                              </Tooltip>
                              Select All Contacts
                               <br/>
                               
                              {/* {checkedList.length > 0 ? ( */}
                               <span><DividerWrapSmall /><Tooltip title="Manage Categories for Selected Contacts">
                               {checkedList.length > 0 ? (
                                <span>{manageCategoriesWidget}</span>
                                ) : (<i
                                  className="icon-tiny fa fa-tag extra-color-3 clickable"
                                  onClick={() => manageCategoryValidation()}
                                />)}
                                </Tooltip> <span>Manage Categories for Selected Contacts </span><br/>  <DividerWrapSmall /></span>
                              {/* ) : null} */}

                              {/* {checkedList.length > 0 ? ( */}
                                <span> <Tooltip title="Email Selected Contacts">
                                  <i
                                    className="icon-tiny fa fa-envelope-o extra-color-3 clickable"
                                    onClick={() => {mailTo();setOpen(false)}}
                                  />
                                </Tooltip> <span>Email Selected Contacts </span><br/>  <DividerWrapSmall /> </span>
                              {/* ) : null} */}
                              {/* {checkedList.length > 0 ? ( */}
                               <span> <Tooltip title="Merge Selected Contacts">
                                  <i
                                    className="icon-tiny fa fa-compress extra-color-3 clickable"
                                    onClick={() => {collideAndMerge();setOpen(false)}}
                                  />
                                </Tooltip> <span>Merge Selected Contacts</span><br/>  <DividerWrapSmall /></span>
                              {/* ) : null} */}
                              {/* {checkedList.length > 0 ? ( */}
                                <span> <Tooltip title="Delete Selected Contacts">
                                  <i
                                    className="icon-tiny fa fa-trash-o extra-color-3 clickable"
                                    onClick={() => {handleDelete();setOpen(false)}}
                                  />
                                </Tooltip> <span>Delete Selected Contacts</span><br/> </span>
                              {/* ) : null} */}
                            </div>
                          </div>
                        </div>
                        </DialogContent>
                        <DialogActions>
                                    <Button
                                      variant="outlined"
                                      onClick={() =>
                                        setOpen(false)
                                      }
                                    >
                                      Close
                                    </Button>
                                                             
                                  </DialogActions>
      </Dialog>
  );
}

  return (
    <ThemeProvider theme={theme}>
      <div
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="4%"
        data-bottom-percent="7%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row top-level full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{
          paddingTop: "calc(100vw * 0.04)",
          paddingBottom: "calc(100vw * 0.07)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-3 wpb_column column_container vc_column_container col padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p
                                style={{
                                  paddingBottom: "0px",
                                  marginBottom: "10px"
                                }}
                                onClick={() => setAddContactModal(true)}
                                className="menuContacts"
                              >
                                <i className="icon-normal fa fa-plus-circle extra-color-gradient-2" />
                                Add Contact
                              </p>
                              <AddContactWidget
                                open={addContactModal}
                                setOpen={setAddContactModal}
                              />
                              <p
                                onClick={() => setImportContactModal(true)}
                                className="menuContacts"
                              >
                                <i className="icon-normal fa fa-arrow-circle-up extra-color-gradient-2" />
                                Import Contacts
                              </p>

                              <Dialog
                                open={importContactModal}
                                onClose={() => setImportContactModal(false)}
                                fullWidth={true}
                                maxWidth="sm"
                              >
                                <DialogTitle>Import Contacts</DialogTitle>
                               
                                  <DialogContent dividers>
                                    <Tabs
                                      value={importSourceTab}
                                      onChange={(e, v) => setImportSourceTab(v)}
                                    >
                                      <Tab label="Google" />
                                      <Tab
                                        label="iCloud"
                                        onClick={e => setImportSource("iCloud")}
                                      />
                                      {/* <Tab
                                        label="Upload CSV"
                                        onClick={e => setImportSource("CSV")}
                                      /> */}
                                    </Tabs>
                                    <div
                                      className={
                                        importSourceTab === 0 ? "" : "hidden"
                                      }
                                    >
                                      {/* <a href="/google-authentication">
                                        Import from Google Contacts
                                      </a> */}
                                    </div>
                                    <div
                                      className={
                                        importSourceTab === 1 ? "" : "hidden"
                                      }
                                    >
                                       <form
                                       id="IcloudForm"
                                  action="/wp-admin/admin-post.php"
                                  method="post"
                                  enctype="multipart/form-data"
                                >
                                  <input
                                    type="hidden"
                                    name="action"
                                    value="request_upload_import"
                                  />
                                      <input
                                        type="text"
                                        name="name"
                                        placeholder="iCloud Email"
                                        required = {true}
                                      />
                                      <br />
                                      Password:{" "}
                                      <input
                                        type="password"
                                        name="password"
                                        placeholder="App-Specific Password"
                                        required = {true}
                                      />
                                      <br />
                                      You must create an{" "}
                                      <a
                                        href="https://support.apple.com/en-us/HT204397"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        app-specific password in iCloud
                                      </a>{" "}
                                      so PRISM can download your contacts. Import may take 1-2 minutes. You may see a blank screen momentarily. When import is completed the contact page will show.
                                      </form>
                                    </div>
                                   
                                    <div
                                      className={
                                        importSourceTab === 2 ? "" : "hidden"
                                      }
                                    >
                                      <select name="file_type" required = {true}>
                                      <option value="">Please select a type</option>
                                        <option value="Google">
                                          Google CSV
                                        </option>
                                        <option value="LinkedIn">
                                          LinkedIn CSV
                                        </option>
                                        <option value="iCloud">
                                          iCloud CSV
                                        </option>
                                      </select>
                                      <br/>
                                      <input
                                        type="hidden"
                                        name="upload_type"
                                        value={importSource}                                      
                                      />
                                      <ul>
                                        <li>
                                          <input type="file" name="file" required = {true} />
                                        </li>
                                      </ul>
                                    </div>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      variant="outlined"
                                      onClick={() =>
                                        setImportContactModal(false)
                                      }
                                    >
                                      Cancel
                                    </Button>
                                    { <div
                                      className={
                                        importSourceTab === 0 ? "" : "hidden"
                                      }
                                    >
                                      {/* <a href="/google-authentication" variant="outlined" >
                                        Import
                                      </a> */}
                                      <Button variant="outlined" type="submit">
                                        <a href="/google-authentication">Import </a>
                                      </Button>
                                    </div> }
                                    <div>
                                    {importSourceTab === 0 ? (
                                     <a></a>
                                    ) : (
                                      <Button variant="outlined" type="button" onClick={() => {document.getElementById('IcloudForm').submit()}}>
                                      Import
                                    </Button>
                                    )}                                  
                                  </div>  
                                  <div>{importSourceTab => importSourceTab++}</div>                              
                                  </DialogActions>
                               
                              </Dialog>
                            </div>
                          </div>

                          <DividerWrapSmall />
                          <ContactsMenu
                            filterCallback={addFilter}
                            filters={filters}
                            clearFilterCallback={clearFilter}
                            contacts={contacts}
                            collisions={collisions}
                            openMerge={openMerge}
                            setOpenMerge={setOpenMerge}
                            wordpressId={props.id}
                            nonce={props.nonce}
                          />

                          <DividerWrapSmall />
                          <Categories
                            categories={categories}
                            categoriesCallback={handleAddCategory}
                            categoryInput={categoryInput}
                            categoryInputCallback={setCategoryInput}
                            addCategoryCallback={handleAddCategory}
                            deleteCallback={deleteCategory}
                            editCallback={editCategory}
                            filterCallback={addFilter}
                            filters={filters}
                          />

                          <DividerWrapSmall />
                          <Networking
                            filterCallback={addFilter}
                            filters={filters}
                            statuses={statuses}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 vc_hidden-lg wpb_column column_container vc_column_container col child_column centered-text no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper mobileContactMenu">
                              <i className="icon-normal fa fa-ellipsis-v extra-color-gradient-2" onClick={() => setMobileSubMenu(true)}/>
                              <MobileSubMenu
                                open={mobileSubMenu}
                                setOpen={setMobileSubMenu}
                              />
                              <i className="icon-normal iconsmind-Filter-2 extra-color-gradient-2"  onClick={() => setmobleCategoryPopup(true)} />
                              <MobilcategorySearch
                               open={mobleCategoryPopup}
                               setOpen={setmobleCategoryPopup} />
                              <i className="icon-normal fa fa-plus-circle extra-color-gradient-2"  onClick={() => setAddContactModal(true)}/>
                              <i className="icon-normal fa fa-arrow-circle-up extra-color-gradient-2"  onClick={() => setImportContactModal(true)}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="vc_col-sm-9 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-3 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <Tooltip title="Select All Contacts">
                                <input
                                  type="checkbox"
                                  onChange={e =>
                                    handleCheckAll(e.target.checked)
                                  }
                                  className="clickable"
                                />
                              </Tooltip>
                              {/* {checkedList.length > 0 ? ( */}
                                <Tooltip title="Manage Categories for Selected Contacts">
                                {checkedList.length > 0 ? (
                                <span>{manageCategoriesWidget}</span>
                                ) : (<i
                                  className="icon-tiny fa fa-tag extra-color-3 clickable"
                                  onClick={() => manageCategoryValidation()}
                                />)}
                                
                                </Tooltip>
                              {/* ) : null} */}
                              {/* {checkedList.length > 0 ? ( */}
                                <Tooltip title="Email Selected Contacts">
                                  <i
                                    className="icon-tiny fa fa-envelope-o extra-color-3 clickable"
                                    onClick={() => mailTo()}
                                  />
                                </Tooltip>
                              {/* ) : null} */}
                              {/* {checkedList.length > 0 ? ( */}
                                <Tooltip title="Merge Selected Contacts">
                                  <i
                                    className="icon-tiny fa fa-compress extra-color-3 clickable"
                                    onClick={() => collideAndMerge()}
                                  />
                                </Tooltip>
                              {/* ) : null} */}
                              {/* {checkedList.length > 0 ? ( */}
                                <Tooltip title="Delete Selected Contacts">
                                  <i
                                    className="icon-tiny fa fa-trash-o extra-color-3 clickable"
                                    onClick={() => handleDelete()}
                                  />
                                </Tooltip>
                              {/* ) : null} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584913336992">
                            <div className="wpb_wrapper">
                              <h6>
                                <span
                                  style={{
                                    color: "#a3a3a3",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                >
                                  <i className="icon-tiny iconsmind-Magnifi-Glass22 extra-color-2" />
                                  <input
                                    type="text"
                                    placeholder="SEARCH: Name, Email, Company, Phone, Notes"
                                    value={searchTerm || ""}
                                    onChange={e => {
                                      setSearchTerm(e.target.value);
                                    }}
                                    style={{ padding: "5px" }}
                                    className="prism"
                                  />
                                </span>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-3 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p style={{ textAlign: "right" }}>
                                <i
                                  className="icon-tiny fa fa-sort-alpha-asc extra-color-3 clickable"
                                  onClick={() =>
                                    setFilteredContacts(
                                      filteredContacts
                                        .slice()
                                        .sort((a, b) =>
                                          sortContacts(b.name, a.name)
                                        )
                                    )
                                  }
                                />
                                <i
                                  className="icon-tiny fa fa-sort-alpha-desc extra-color-3 clickable"
                                  onClick={() =>
                                    setFilteredContacts(
                                      filteredContacts
                                        .slice()
                                        .sort((a, b) =>
                                          sortContacts(a.name, b.name)
                                        )
                                    )
                                  }
                                />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 vc_hidden-lg wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="left-right"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584913336992">
                            <div
                              className="wpb_wrapper"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <i className="icon-tiny iconsmind-Magnifi-Glass22 extra-color-2" />
                              <input
                                type="text"
                                placeholder="SEARCH: Name, Email, Company, Phone, Notes"
                                value={searchTerm || ""}
                                onChange={e => {
                                  setSearchTerm(e.target.value);
                                }}
                                style={{ padding: "5px" }}
                                className="prism"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <DividerWrap />
                {filteredContacts.slice(page, page + 10).map(c => (
                  <div key={c.id}>
                    <ContactRow
                      contact={c}
                      checked={checkedList.includes(parseInt(c.id, 10))}
                      checkboxCallback={handleCheck}
                    />
                    <DividerWrap />
                  </div>
                ))}
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <p style={{ textAlign: "center" }}>
                      <span style={{ color: "#a3a3a3", fontSize: "small" }}>
                        {filteredContacts.length === 0 ? 0 : page + 1}-
                        {filteredContacts.length < 10
                          ? filteredContacts.length
                          : page + 10}{" "}
                        of {filteredContacts.length}
                      </span>
                      <i
                        className="icon-tiny fa fa-chevron-left extra-color-1 clickable"
                        onClick={() =>
                          setPage(() => (page === 0 ? 0 : page - 10))
                        }
                      />
                      <i
                        className="icon-tiny fa fa-chevron-right extra-color-1 clickable"
                        onClick={() =>
                          setPage(() =>
                            page + 10 > filteredContacts.length
                              ? page
                              : page + 10
                          )
                        }
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default ContactsPage;